/**
 * Page - Cold Traffic Checkout JS
 */

// CSS
import styles from '../scss/ct-checkout.scss';
jQuery('.woocommerce-billing-fields')
  .children('h3')
  .after(
    '<img id="fields-loading" src="https://cdn.simplertrading.com/2019/01/07153105/loading.gif">'
  );
jQuery('.checkout-cart').append(
  '<a id="checkout-contact" href="tel:5122668659"><div id="checkout-contact-inner"><img src="https://cdn.simplertrading.com/2019/01/07150234/phone-333333-smaller.png" /> Need Help? Call (512) 266-8659</div></a>'
);
jQuery('.cart-discount').children('th').text('Exclusive Discount');
const accountCheckbox = jQuery('input#createaccount');
if (accountCheckbox.length > 0) {
  accountCheckbox.prop('checked', true);
}
window.setTimeout(function () {
  jQuery('#fields-loading').remove();
  jQuery('.form-row-wrapper').css('opacity', 1);
}, 1500);
